import { render, staticRenderFns } from "./TemplateChoiceCards.vue?vue&type=template&id=89349590"
import script from "./TemplateChoiceCards.vue?vue&type=script&lang=js"
export * from "./TemplateChoiceCards.vue?vue&type=script&lang=js"
import style0 from "./TemplateChoiceCards.vue?vue&type=style&index=0&id=89349590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports